import Vue from "vue";
import SearchTeaser from "./views/SearchTeaser/SearchTeaser.vue";
import Vuetify from "vuetify/lib";
import { getURLParamsObject } from "@/helpers/commonHelper";

Vue.config.productionTip = false;
Vue.use(Vuetify);

// loading wrapper for each instance
const $elements = document.getElementsByClassName("eoev-sp-widget");
const savedElements = []; // save elements to array, since array will otherwise be reduce while looping
for (let i = 0; i < $elements.length; i++) {
  savedElements.push($elements[i]);
}

const colorConfig = getURLParamsObject(true);

for (let i = 0; i < savedElements.length; i++) {
  const $el = savedElements[i];

  const getColor = (key, defaultValue) =>
    $el.attributes[`data-${key}`]?.value || colorConfig?.[key] || defaultValue;

  // build vuetify instance using certain colors
  const opts = {
    icons: {
      iconfont: "mdiSvg"
    },
    theme: {
      themes: {
        light: {
          primary: getColor("color-primary", "#97bd0f"),
          secondary: getColor("color-secondary", "#5d7114"),
          accent: getColor("color-accent", "#2468c9"),
          error: getColor("color-error", "#c55c52"),
          info: getColor("color-info", "#314d57"),
          success: getColor("color-success", "#97bd0f"),
          warning: getColor("color-warning", "#e2d7af")
        }
      }
    }
  };
  const vuetify = new Vuetify(opts);

  // set as constants to avoid overwriting of settings below
  const id = $el.attributes.id && $el.attributes.id.value;
  const listUri =
    $el.attributes["data-list-uri"] && $el.attributes["data-list-uri"].value;
  const apiUrl =
    $el.attributes["data-api-url"] && $el.attributes["data-api-url"].value;
  const apiKey =
    $el.attributes["data-api-key"] && $el.attributes["data-api-key"].value;
  const locale =
    ($el.attributes["data-locale"] && $el.attributes["data-locale"].value) ||
    "de-de";
  const firstDayOfWeek =
    ($el.attributes["data-first-day-of-week"] &&
      $el.attributes["data-first-day-of-week"].value) ||
    1;

  // no vuex here!

  new Vue({
    vuetify,
    render: function(h) {
      return h(SearchTeaser, {
        props: {
          id: id,
          "list-uri": listUri,
          "api-url": apiUrl,
          "api-key": apiKey,
          locale: locale,
          "first-day-of-week": firstDayOfWeek
        }
      });
    }
  }).$mount($el);
}
